import * as actions from './userListActionTypes';
import { getUserList } from '../utils/piction';
import { SESSION_EXPIRED_MESSAGE } from '../constants/sessionStateTypes';
import { sessionExpired } from './session';

export const getUsersRequest = () => ({
  type: actions.USER_LIST_REQUEST,
});

export const getUsersSuccess = (res) => ({
  type: actions.USER_LIST_SUCCESS,
  res,
});

export const getUsersFailure = (error) => ({
  type: actions.USER_LIST_FAILURE,
  error,
});

export const getUsers = (isFullList) =>
  function getUsersDispatch(dispatch) {
    dispatch(getUsersRequest());

    return getUserList(isFullList)
      .then((res) => {
        const userList = res.map(user => user._);
        dispatch(getUsersSuccess(userList));
        return isFullList ? res : userList;
      })
      .catch((error) => {
        if (error.message && error.message.includes(SESSION_EXPIRED_MESSAGE)) {
          dispatch(sessionExpired(error));
        } else {
          dispatch(
            getUsersFailure(error)
          );
        }
        return error;
      });
  };

export const getUsersDismiss = () => ({
  type: actions.USER_LIST_DISMISS,
});



// WEBPACK FOOTER //
// ./src/js/actions/userList.js